module.exports = __webpack_public_path__ + "img/hidelike.a67a80ae.svg";